// Mock data para mensagens do ChatJess
import { ChatJessMessage } from "../../pages/Dashboard/ChatJess/types";

export const mockChatJessMessages: ChatJessMessage[] = [
  // Regular AI message
  {
    id: "msg-1",
    author: "jess",
    content:
      "Olá! 👋 Sou a Jess, sua assistente virtual. Estou aqui para ajudar com qualquer dúvida ou necessidade que você tenha. Como posso ajudá-lo hoje?",
    timestamp: new Date(Date.now() - 300000), // 5 minutos atrás
    messageType: "text",
  },
  // User message with document attachment
  {
    id: "msg-2",
    author: "human",
    content:
      "Oi Jess! Preciso de ajuda para analisar este relatório financeiro.",
    timestamp: new Date(Date.now() - 280000), // 4.7 minutos atrás
    messageType: "mixed",
    userName: "João Silva",
    attachments: [
      {
        id: "doc-1",
        name: "Relatório_Financeiro_Q3_2024.pdf",
        size: 2458340, // ~2.4MB
        type: "application/pdf",
        url: "blob:http://localhost:3000/mock-pdf-1",
      },
    ],
  },
  // User message with image attachment
  {
    id: "msg-2.5",
    author: "human",
    content: "Aqui está a foto do problema que estou enfrentando:",
    timestamp: new Date(Date.now() - 275000),
    messageType: "mixed",
    userName: "João Silva",
    attachments: [
      {
        id: "img-1",
        name: "problema_sistema.jpg",
        size: 1245680, // ~1.2MB
        type: "image/jpeg",
        url: "https://picsum.photos/400/300?random=1",
        thumbnail: "https://picsum.photos/100/75?random=1",
      },
    ],
  },
  // Regular AI message
  {
    id: "msg-3",
    author: "jess",
    content:
      "Perfeito! Vou analisar o relatório financeiro que você enviou. Vi também a imagem do problema no sistema. Vou processar essas informações e te dar um retorno completo.",
    timestamp: new Date(Date.now() - 260000), // 4.3 minutos atrás
    messageType: "text",
  },
  // AI message with multiple attachments (documents)
  {
    id: "msg-3.5",
    author: "jess",
    content:
      "Baseado na análise do seu relatório, preparei alguns documentos que podem te ajudar:",
    timestamp: new Date(Date.now() - 250000),
    messageType: "mixed",
    attachments: [
      {
        id: "doc-2",
        name: "Análise_Detalhada_Q3.docx",
        size: 856234, // ~856KB
        type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        url: "blob:http://localhost:3000/mock-doc-1",
      },
      {
        id: "doc-3",
        name: "Planilha_Projeções_2025.xlsx",
        size: 445621, // ~445KB
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        url: "blob:http://localhost:3000/mock-excel-1",
      },
      {
        id: "doc-4",
        name: "Backup_Config.zip",
        size: 1563421, // ~1.5MB
        type: "application/zip",
        url: "blob:http://localhost:3000/mock-zip-1",
      },
    ],
  },
  // Long message to test "Read more" functionality
  {
    id: "msg-4",
    author: "jess",
    content:
      "Baseado na análise das suas conversas dos últimos dias, identifiquei alguns padrões interessantes que podem ajudar a otimizar o atendimento:\n\n1. **Horários de maior demanda**: Entre 9h-11h e 14h-16h há um pico de mensagens. Recomendo ter mais agentes disponíveis nesses períodos.\n\n2. **Principais dúvidas dos clientes**:\n   - Informações sobre preços e planos (35%)\n   - Suporte técnico (28%)\n   - Dúvidas sobre funcionalidades (22%)\n   - Solicitações de cancelamento (15%)\n\n3. **Tempo de resposta**: A média atual é de 8 minutos, mas clientes que aguardam mais de 5 minutos tendem a demonstrar insatisfação. Sugiro implementar respostas automáticas para casos que demoram mais que 3 minutos.\n\n4. **Oportunidades de melhoria**:\n   - Criar um FAQ mais detalhado para reduzir dúvidas recorrentes\n   - Implementar chatbots para triagem inicial\n   - Oferecer demonstrações em vídeo para funcionalidades complexas\n\n5. **Feedback dos clientes**: 87% das avaliações são positivas, mas há reclamações sobre demora no atendimento de casos técnicos específicos.\n\nGostaria que eu elabore um plano de ação detalhado para algum desses pontos específicos?",
    timestamp: new Date(Date.now() - 240000), // 4 minutos atrás
    messageType: "text",
  },
  // Message with only attachments (no text)
  {
    id: "msg-4.5",
    author: "human",
    content: "",
    timestamp: new Date(Date.now() - 235000),
    messageType: "file",
    userName: "João Silva",
    attachments: [
      {
        id: "img-2",
        name: "screenshot_erro.png",
        size: 1876543, // ~1.8MB
        type: "image/png",
        url: "https://picsum.photos/600/400?random=2",
        thumbnail: "https://picsum.photos/150/100?random=2",
      },
      {
        id: "doc-5",
        name: "log_sistema.txt",
        size: 12580, // ~12KB
        type: "text/plain",
        url: "blob:http://localhost:3000/mock-txt-1",
      },
    ],
  },
  // First feedback request
  {
    id: "1",
    author: "jess",
    content:
      "Um cliente está solicitando que eu processe seu reembolso imediatamente, mas preciso da sua aprovação para continuar.",
    timestamp: new Date(Date.now() - 220000), // 3.7 minutos atrás
    messageType: "text",
    feedbackId: "feedback-1",
    feedbackTitle: "Solicitação de Reembolso",
    feedbackDetails:
      "O cliente João solicitou reembolso de R$ 299,90 referente à compra do produto XYZ. Ele alegou que o produto chegou com defeito e já enviou fotos comprovando o problema.",
    supportType: "requiresHumanAction",
    isCompleted: true,
    supportMessages: [
      {
        question:
          "Poderia aprovar o reembolso de R$ 299,90 para o cliente João referente ao produto XYZ que chegou defeituoso?",
        answer:
          "Aprovado! Pode processar o reembolso. O cliente já forneceu as evidências necessárias.",
      },
      {
        question:
          "Em quanto tempo devo informar ao cliente que o reembolso será processado?",
        answer: "Informe que o reembolso será processado em até 5 dias úteis.",
      },
      {
        question:
          "Devo oferecer alguma compensação adicional pelo inconveniente?",
      },
    ],
  },
  // Regular AI message
  {
    id: "msg-5",
    author: "jess",
    content:
      "Entendido! Vou processar o reembolso conforme sua aprovação. O cliente será notificado sobre o prazo de 5 dias úteis. 💳✅",
    timestamp: new Date(Date.now() - 180000), // 3 minutos atrás
    messageType: "text",
  },
  // Second feedback request
  {
    id: "2",
    author: "jess",
    content:
      "Um cliente perguntou sobre os horários de funcionamento do suporte técnico nos fins de semana, mas não tenho essa informação atualizada.",
    timestamp: new Date(Date.now() - 120000), // 2 minutos atrás
    messageType: "text",
    feedbackId: "feedback-2",
    feedbackTitle: "Horários do Suporte",
    feedbackDetails:
      "A cliente Ana precisa de suporte técnico urgente no sábado pela manhã e quer saber se o suporte funciona nos fins de semana.",
    supportType: "requiresHumanAnswer",
    isCompleted: true,
    supportMessages: [
      {
        question:
          "Qual é o horário de funcionamento do suporte técnico nos fins de semana?",
        answer:
          "O suporte técnico funciona aos sábados das 8h às 14h. Aos domingos não há atendimento, apenas para emergências críticas.",
      },
      {
        question:
          "Devo informar a cliente que o suporte está disponível no sábado pela manhã?",
      },
    ],
  },
  // Regular AI message
  {
    id: "msg-6",
    author: "jess",
    content:
      "Perfeito! Vou informar à cliente Ana que o suporte está disponível aos sábados das 8h às 14h. Isso atende perfeitamente à necessidade dela! 📞",
    timestamp: new Date(Date.now() - 90000), // 1.5 minutos atrás
    messageType: "text",
  },
  // Regular AI message
  {
    id: "msg-7",
    author: "jess",
    content:
      "Identifiquei mais uma situação que precisa da sua orientação. É sobre política de descontos por volume.",
    timestamp: new Date(Date.now() - 60000), // 1 minuto atrás
    messageType: "text",
  },
  // Third feedback request
  {
    id: "3",
    author: "jess",
    content:
      "Um cliente está perguntando se oferecemos desconto para compras em quantidade. Como devo proceder?",
    timestamp: new Date(Date.now() - 30000), // 30 segundos atrás
    messageType: "text",
    feedbackId: "feedback-3",
    feedbackTitle: "Política de Desconto por Volume",
    feedbackDetails:
      "O cliente Marcos quer comprar 50 unidades do produto ABC e está perguntando sobre descontos por volume. Ele é um cliente recorrente e já fez várias compras.",
    supportType: "requiresHumanAnswer",
    isCompleted: false,
    supportMessages: [
      {
        question:
          "Oferecemos desconto para compras em quantidade? Se sim, qual é a política e quais são os percentuais aplicados?",
      },
      {
        question:
          "Devo informar ao cliente sobre os percentuais de desconto e perguntar se ele gostaria de prosseguir com a compra?",
      },
    ],
  },
  // Regular AI message
  {
    id: "msg-8",
    author: "jess",
    content:
      "Enquanto aguardo sua resposta sobre os descontos, vou continuar monitorando outras conversas. Se surgir algo urgente, aviso imediatamente! 🤖💬",
    timestamp: new Date(),
    messageType: "text",
  },
];
